import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';

const Container = styled(Grid)`
  height: auto;
  width: 100%;
  margin-bottom: 100px;
  padding-right: 70px;
  @media (max-width: 768px) {
    padding-top: unset;
    margin-bottom: 60px;
    padding: 0 20px;
  }
`;
const Title = styled(Typography)`
  color: #251628;
  text-align: center;
  font-family: var(--font-work-sans);
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 159.3%;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
`;
const Content = styled(Grid)`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  margin-top: 100px;
`;
const Subtitle = styled(Typography)`
  color: #251628;
  font-family: var(--font-work-sans);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 159.3%;
  align-items: center;
  text-align: justify;
  @media (max-width: 768px) {
  }
`;
interface WhatToDoProps {
  text: string;
}
const WhatToDo = ({ text }: WhatToDoProps) => {
  return (
    <Container container>
      <Content item>
        <Title>What Will You Do?</Title>
        <Subtitle>{text}</Subtitle>
      </Content>
    </Container>
  );
};

export default WhatToDo;
